export default __webpack_public_path__ + "static/media/9.c1ecb427.jpg";